import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";
import { get } from "react-hook-form";

export const useAlerts = () => {


    const getAlertsNoRead = useCallback(async (signal) => {
    
        const response = await fetch(`${getClientDomain()}/alerts/noread`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
        });
    
        const result = await response.json();        
        
        if (result?.payload?.length > 0) {
            return result.payload;
        } else {
            return [];
        }
    }, []);

    const getAllAlerts = useCallback(async (signal) => {
    
        const response = await fetch(`${getClientDomain()}/alerts/all`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
        });
    
        const result = await response.json();        
        
        if (result?.payload?.length > 0) {
            return result.payload;
        } else {
            return [];
        }
    }, []);

    const readAlerts = useCallback(async (signal, data) => {
    
        const response = await fetch(`${getClientDomain()}/alerts/read`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal,
            body: JSON.stringify(data)
        });
    
        const result = await response.json();        
        
        if (result) {
            return result;
        } else {
            return [];
        }
    }, []);
    


    return { getAlertsNoRead, getAllAlerts, readAlerts };
}